import axios from "axios";
import { API_URL } from "../../constants";
import _ from "lodash";

export default {
  getAllspecificClients: () => {
    return axios.get(API_URL.SPECIFICOFFERCLIENTS, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  getAllspecificEmails: (data) => {
    return axios.get(`${API_URL.SPECIFICOFFEREMAILS}/${data}`, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  getAllspecificProduct: () => {
    return axios.get(`${API_URL.GETALLSPECIFICPRODUCT}/mci`, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  createSpecificoffer: (data) => {
    return axios.post(API_URL.SPECIFICOFFER, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  getAllspecificOfferId: (id) => {
    return axios.get(`${API_URL.SPECIFICOFFER}/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  updateSpecificOfferId: (id, data) => {
    return axios.patch(`${API_URL.SPECIFICOFFER}/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },

  getAllspecificProductList: (page, pageSize, searchparams) => {
    const filteredParams = _.pickBy(
      searchparams,
      (value) => !_.isNil(value) && value !== false && value !== ""
    );
    return axios.get(API_URL.SPECIFICOFFER, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
      params: {
        from_date: filteredParams.from,
        to_date: filteredParams.to,
        username: filteredParams.client,
        product_uuid: filteredParams.product,
        product_plan_uuid: filteredParams.plan,
        status: filteredParams.status,
        page: page,
        pageSize: pageSize,
      },
    });
  },
  getAllspecificClientFilter: (pageSize, client) => {
    return axios.get(API_URL.SPECIFICOFFER, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
      params: {
        pageSize: pageSize,
        user_uuid: client,
      },
    });
  },
  getAllspecificProductFilter: (pageSize, product) => {
    return axios.get(API_URL.SPECIFICOFFER, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
      params: {
        pageSize: pageSize,
        user_uuid: product,
      },
    });
  },
  getAllspecificPlanFilter: (pageSize, plan) => {
    return axios.get(API_URL.SPECIFICOFFER, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
      params: {
        pageSize: pageSize,
        product_uuid: plan
      },
    });
  },
  // general
  createGeneraloffer: (data) => {
    return axios.post(API_URL.GENERALOFFER_CREATE, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  updateGeneralOfferId: (id, data) => {
    return axios.patch(`${API_URL.GENERALOFFER_CREATE}/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  getAllgeneralProductList: (page, pageSize, searchparams) => {
    const filteredParams = _.pickBy(
      searchparams,
      (value) => !_.isNil(value) && value !== false && value !== ""
    );
    return axios.get(API_URL.GENERALOFFERBYID, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
      params: {
        from_date: filteredParams.from,
        to_date: filteredParams.to,
        user_uuid: filteredParams.client,
        product_uuid: filteredParams.product,
        product_plan_uuid: filteredParams.plan,
        status: filteredParams.status,
        frequency:filteredParams.frequency,
        page: page,
        pageSize: pageSize,
      },
    });
  },
  getAllgeneralOfferId: (id) => {
    return axios.get(`${API_URL.GENERALOFFERBYID}/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  getAllgeneralProductFilter: (pageSize, product) => {
    return axios.get(API_URL.GENERALOFFER, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
      params: {
        pageSize: pageSize,
        user_uuid: product,
      },
    });
  },
  getAllgeneralPlanFilter: (pageSize, plan) => {
    return axios.get(API_URL.GENERALOFFER,{
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
      params: {
        pageSize: pageSize,
        product_uuid: plan
      },
    });
  },
};

